import { useSelector } from "react-redux";
import { selectVendorInheritance } from "../app/sessionSlice";
import { SessionChecks, type SessionCheck } from "../featureToggler/types";
import type { VendorInheritance } from "../shared/vendorInheritance";

type State = Parameters<typeof selectVendorInheritance>[0];

/**
 * Resolves a feature's `sessionCheck` key against the session. Each key has its own rule (and its
 * own polarity), added as a branch below; a missing key places no session restriction.
 * The check runs inside a single `useSelector` call, so hook order never depends on the key.
 * @param {SessionCheck} [sessionCheck] - key from the feature flag
 * @returns {boolean} true when the feature is allowed by the session
 */
export const useSessionCheck = (sessionCheck?: SessionCheck): boolean =>
    useSelector((state: State) => {
        if (sessionCheck === SessionChecks.VendorInheritance) {
            // `isInheritingChild` already means "account setting enabled AND company is an
            // inheriting child" (see normalizeVendorInheritance), so vendor writes are blocked
            // only in that case.
            return !(selectVendorInheritance(state) as VendorInheritance).isInheritingChild;
        }
        return true;
    });
